import React from "react";
import {
  CircuitBoard,
  FileText,
  MonitorDot,
  Settings,
  SubscriptIcon,
  UserRound,
  UsersRound,
  File,
  User,
} from "lucide-react";
import { RoutePath } from "routes/route-path";
import { BrandingData } from "admin-portal/settings/branding";
import { AppDispatch } from "slices/store";
import { useAppSelector, useAppDispatch } from "slices/hook";
import { getAuthState } from "slices/auth/login/reducer";
import { UserRoles } from "models/enums";

const adminMenuData: any = [
  {
    label: "menu",
    isTitle: true,
  },
  {
    id: "dashboard",
    label: "Dashboards",
    link: "/#",
    icon: <MonitorDot />,
  },
  {
    label: "Apps",
    isTitle: true,
  },
  {
    id: "tenant-management",
    label: `${BrandingData.bussinessDomain} Management`,
    icon: <CircuitBoard />,
    parentId: "tenantmanagement",
    link: RoutePath.Admin_TenantManage,
    roles: [UserRoles.SYSTEM_ADMIN, UserRoles.TENANT_ADMIN],
  },
  {
    id: "subscription-management",
    label: `Subscription`,
    icon: <SubscriptIcon />,
    parentId: "subscriptionManagement",
    link: RoutePath.Admin_Subscriptions,
    roles: [UserRoles.SYSTEM_ADMIN, UserRoles.TENANT_ADMIN],
    /* subItems: [
      {
        id: "subscriptions",
        label: `Subscriptions`,
        link: RoutePath.Admin_Subscriptions,
        parentId: "subscriptionManagement",
      },
      {
        id: "manage-subscription",
        label: `Create subscription`,
        link: RoutePath.Admin_Subscription_new,
        parentId: "subscriptionManagement",
      },
    ], */
  },
  {
    id: "setup-management",
    label: `Data Setup`,
    icon: <Settings />,
    parentId: "dataSetupManagement",
    link: "/#",
    subItems: [
      /*  {
        id: "service-types",
        label: `Service Types`,
        link: RoutePath.Admin_ServiceTypes,
        parentId: "dataSetupManagement",
      }, */
      {
        id: "services",
        label: `Services`,
        link: RoutePath.Admin_Services,
        parentId: "dataSetupManagement",
      },
      {
        id: "products",
        label: `Products`,
        link: RoutePath.Admin_Products,
        parentId: "dataSetupManagement",
      },
      {
        id: "promotions",
        label: `Promotions`,
        link: RoutePath.Admin_Promotions,
        parentId: "dataSetupManagement",
      },
    ],
    roles: [UserRoles.SYSTEM_ADMIN, UserRoles.TENANT_ADMIN],
  },
  {
    id: "job-management",
    label: `Job`,
    icon: <Settings />,
    parentId: "jobManagement",
    link: "/#",
    subItems: [
      {
        id: "job-create",
        label: `Create a Job`,
        link: RoutePath.Admin_Job_create,
        parentId: "jobManagement",
      },
      {
        id: "jobs",
        label: `Jobs`,
        link: RoutePath.Admin_Job_list,
        parentId: "jobManagement",
      },
      {
        id: "vehicles",
        label: `Vehicles`,
        link: RoutePath.Admin_Vehicles,
        parentId: "jobManagement",
      },
      {
        id: "customer",
        label: `Customers`,
        link: RoutePath.Admin_Customers,
        parentId: "jobManagement",
      },
    ],
  },
  {
    id: "referrer-management",
    label: `Referrer`,
    icon: <CircuitBoard />,
    parentId: "referrermanagement",
    link: RoutePath.Admin_Referrer,
    roles: [UserRoles.SYSTEM_ADMIN, UserRoles.TENANT_ADMIN],
  },
  {
    id: "reportManagement",
    label: `Reports`,
    icon: <File />,
    parentId: "reportManagement",
    link: "/#",
    roles: [UserRoles.SYSTEM_ADMIN, UserRoles.TENANT_ADMIN],
    subItems: [
      {
        id: "daily-sales",
        label: `Daily Sales`,
        link: RoutePath.Admin_Report_Daily_Sales,
        parentId: "reportManagement",
      },
      {
        id: "revenue",
        label: `Revenue`,
        roles: [UserRoles.SYSTEM_ADMIN, UserRoles.TENANT_ADMIN],
        link: RoutePath.Admin_Report_Revenue,
        parentId: "reportManagement",
      },
      {
        id: "products",
        label: `Products`,
        link: RoutePath.Admin_Report_Products,
        parentId: "reportManagement",
      },
    ],
  },
];

export { adminMenuData };
